<template>
    <div>
       <div v-html="content"></div>
    </div>
</template>
<script>
export default{
    data(){
        return{
            content: ''
        }
    },
    created(){
        this.getData()
    },
    methods:{
        getData(){
            this.axios.get('/sys/sysText/get?id=1')
            .then(res=>{
                console.log(res)
                this.content = res.data.content
            })
        }
    }
}
</script>
<style>

</style>